angular.module('MyHippoProducer.Controllers').directive('optionalAdditionalInsuredSection', function () {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: 'pages/policy-details/sections/optional-additional-insured/optional-additional-insured.html',
    };
});
